export const inspectTable_1 = [
  {
    content: "자격을 갖춘 자에게 운전을 하도록 하여야 한다.",
    isChecked: "",
    title: "운전자 적정여부",
  },
  {
    content: "형식신고 및 안전인증·검사 등 기계별 필요한 검사를 받았는지 확인한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "건설기계의 운행경로 및 작업방법을 고려해 기계별 작업계획을 수립·이행하고, 작업지휘자를 지정하여 지휘·감독한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "작업 전 운전자 및 작업자 안전교육을 실시한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "작업장소의 지형 및 지반상태를 확인하고, 기계가 넘어질 우려가 없도록 조치한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "작업구간에 작업자의 출입을 금지하거나 유도자를 배치하여 차량을 유도하여야 한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "유도자는 정해진 신호방법에 따라 차량을 유도한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "건설기계는 주된 용도로만 사용하여야 한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "승차석이 아닌 곳에 작업자를 탑승시키지 않는다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "지정된 제한속도를 준수하여야 한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "방호장치를 임의로 해체하지 않는다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "포크, 버킷, 디퍼 등의 장치를 가장 낮은 위치 또는 지면에 내려 두고, 브레이크를 확실히 걸어 갑작스러운 이동을 방지한다.",
    isChecked: "",
    title: "운전위치 이탈 시",
  },
  {
    content: "운전석 이탈 시 시동키를 운전대에서 분리시킨다.",
    isChecked: "",
    title: "운전위치 이탈 시",
  },
  {
    content: "작업지휘자를 지정하고 작업순서를 정하여 지휘한다.",
    isChecked: "",
    title: "수리 등 점검 시",
  },
  {
    content: "붐·암 등이 갑자기 내려오지 않도록 안전지지대 또는 안전블록을 사용한다.",
    isChecked: "",
    title: "수리 등 점검 시",
  },
];
export const inspectTable_2 = [
  {
    content: "1.\t 굴착기 운전자의 적정 자격을 확인한다.<br/>" + "       *3톤 미만 : 소형건설기계 조종교육 이수<br/>       ** 3톤 이상: 건설기계조종사면허(굴착기) ",
    isChecked: "",
    title: "운전자 적정여부",
  },
  {
    content: "굴착기 운행경로 및 작업방법 등을 고려한 작업계획을 수립하고 이행한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "작업장소의 지형 및 지반상태를 확인하고, 굴착기가 넘어질 우려가 없도록 조치한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "전조등의 정상적인 작동 및 사이드미러나 후사경의 설치상태가 양호한지 점검한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "작업장소에 작업자의 출입을 통제하거나, 유도자를 배치하여 작업자가 부딪히지 않도록 유도한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "운전원은 안전띠를 착용한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "굴착기 버킷 이탈방지용 안전핀을 체결한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "굴착기 버킷에 작업자의 탑승을 금지한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "운전석 이탈 시 버킷은 지상에 내려놓고 시동키는 차에서 분리시켜야 한다.",
    isChecked: "",
    title: "운전자 이탈 시",
  },
  {
    content: "붐·암 등이 갑자기 내려오지 않도록 안전지지대 또는 안전블록을 사용한다.",
    isChecked: "",
    title: "수리 등 점검시",
  },
];

export const inspectTable_3 = [
  {
    content: "고소작업대에 대한 작업계획서*를 작성하고 이행한다.<br/>" + "       *추락·낙하·전도·협착·붕괴 위험대책, 운행경로 및 작업방법",
    isChecked: "",
    title: "공통",
  },
  {
    content: "작업지휘자 또는 유도자를 배치하여 작업계획서에 따라 작업을 지휘하여야 한다.",
    isChecked: "",
    title: "공통",
  },
  {
    content: "작업대에 탑승하는 작업자는 안전모 및 안전대를 착용하여야 한다.",
    isChecked: "",
    title: "공통",
  },
  {
    content: "작업대에 정격하중을 초과하여 물건을 싣거나 탑승하지 않는다.",
    isChecked: "",
    title: "공통",
  },
  {
    content: "작업구간에 관계 작업자가 아닌 사람의 출입을 금지한다.",
    isChecked: "",
    title: "공통",
  },
  {
    content: "조종사의 적정 자격을 확인한다.<br/>" + "      *기중기운전기능사 또는 교육 이수",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "안전인증 및 안전검사 실시 여부를 확인한다.",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "아웃트리거 및 브레이크 등을 확실히 사용하며 아웃트리거는 지면과 수평을 유지하도록 설치한다.",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "붐 길이와 각도에 적합한 적재하중 및 허용 작업반경을 확인한다.",
    isChecked: "",
    title: "차량탑재형",
  },
  {
    content: "안전인증 표시가 부착되어 있는지 확인한다.",
    isChecked: "",
    title: "시저형",
  },
  {
    content: "작업대 안전난간의 파손 및 탈락여부를 확인한다.",
    isChecked: "",
    title: "시저형",
  },
  {
    content: "고소작업대는 항상 바닥과 수평을 유지하도록 한다.",
    isChecked: "",
    title: "시저형",
  },
  {
    content: "작업대에 과상승방지장치를 설치하고 작동유무를 확인한다.",
    isChecked: "",
    title: "시저형",
  },
  {
    content: "작업대를 올린 상태에서 작업자를 태우고 이동하지 않는다.",
    isChecked: "",
    title: "시저형",
  },
];
export const inspectTable_4 = [
  {
    content: "운전원은 적정 면허 자격*을 갖추어야 한다.<br/>* 건설기계조종사면허(기중기) <br/>" + "       ** 기중기운전기능사 또는 교육 이수(카고크레인)",
    isChecked: "",
    title: "운전자 및 기계 적정여부",
  },
  {
    content: "「건설기계관리법」상의 형식신고* 및「산업안전보건법」상 안전인증 및  안전검사** 여부를 확인한다.<br/>" + "         * \t기중기<br/>         ** 차량탑재형 크레인",
    isChecked: "",
    title: "운전자 및 기계 적정여부",
  },
  {
    content: "작업전 작업자 배치 및 교육, 작업방법, 방호장치 등 필요한 사항에 대한 조치를 실시한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "중량물 취급작업에 대한 작업계획을 수립하고 이행한다.<br/>" + "       *추락·낙하·전도·협착·붕괴위험을 예방할 수 있는 안전대책",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "정격하중, 속도, 경고표시 등을 작업자가 보기 쉬운 곳에 부착한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "과부하장지장치, 권과방지장치, 비상정지장치 및 제동장치, 그 밖의 방호장치가 정상적으로 작동하는지 점검한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "인양 작업 구간에 작업자의 출입을 통제하여 인양 중인 하물이 작업자의 머리 위로 통과하지 않도록 한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "이동식 크레인을 사용하여 작업자를 운반하거나 달아 올린 상태에서 작업을 실시하지 않는다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "적재하중을 초과하지 않도록 작업한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "훅 해지장치를 사용하여 인양물의 이탈을 방지한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "운전자는 운전위치를 이탈하지 않는다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
];
export const inspectTable_5 = [
  {
    content: "운전원은 적정한 면허자격*을 갖추어야 한다.<br/>* 덤프트럭(1종 대형), 화물자동차(12톤 이상: 1종 대형, 12톤 미만: 1종 보통)",
    isChecked: "",
    title: "운전원 자격확인",
  },
  {
    content: "트럭 운행경로 및 작업방법 등을 고려한 작업계획을 수립하고 이행한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "상하차 작업을 하는 장소에 지형 및 지반의 상태를 확인하고 덤프트럭이 넘어지지 않도록 조치한다.",
    isChecked: "",
    title: "운전 시작 전 안전조치",
  },
  {
    content: "하역 또는 운반작업 구간에 작업자의 출입을 통제하거나, 유도자를 배치하여 작업자와의 충돌을 방지한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "주·정차 시 브레이크를 체결하고 경사면인 경우 고임목을 설치한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "적재함 상하차 작업 시 안전모를 착용한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "화물 적재함에 근로자의 탑승 및 과적을 금지한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "현장 내 제한속도를 표시하고 준수한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "운전자는 안전벨트를 착용한다.",
    isChecked: "",
    title: "운행 및 작업 중 안전조치",
  },
  {
    content: "운전자가 운전대를 이탈할 경우, 적재함을 내리고 시동 키를 운전석으로 분리한다.",
    isChecked: "",
    title: "운전자 이탈 시",
  },
];
export const inspectTable_6 = [
  {
    content: "타워크레인 운전원*의 자격을 확인한다.<br/>" + "      *건설기계조종사면허(타워크레인)",
    isChecked: "",
    title: "공통",
  },
  {
    content: "타워크레인의 신호업무 담당자를 배치하고 교육한다.",
    isChecked: "",
    title: "공통",
  },
  {
    content: "타워크레인 상부 작업자는 안전모 및 안전대를 착용한다.",
    isChecked: "",
    title: "공통",
  },
  {
    content: "작업 구간에 관계 작업자가 아닌 사람의 출입을 금지한다.",
    isChecked: "",
    title: "공통",
  },
  {
    content: "중량물 취급작업에 대한 작업계획*을 수립·이행한다.<br/>" + "      *추락·낙하·전도·협착·붕괴위험을 예방할 수 있는 안전대책",
    isChecked: "",
    title: "공통",
  },
  {
    content: "설치·해체 작업자의 자격*을 확인한다.<br/>" + "       *판금제관기능사 또는 비계기능사, 관련 교육 이수자",
    isChecked: "",
    title: "설치·해체 작업",
  },
  {
    content: "설치·해체 작업에 대한 작업계획을 수립하고 제조사의 설치작업설명서 등에 따라 설치·해체한다.",
    isChecked: "",
    title: "설치·해체 작업",
  },
  {
    content: "타워크레인 조립 시 작업의 순서를 정하고 그 순서를 준수한다.",
    isChecked: "",
    title: "설치·해체 작업",
  },
  {
    content: "타워크레인에 충돌방지 장치를 설치하고, 설치·해체 작업 과정을 영상으로 기록·보존한다.",
    isChecked: "",
    title: "설치·해체 작업",
  },
  {
    content: "자립고 이상에서 벽체 지지방법의 준수를 확인한다.",
    isChecked: "",
    title: "설치·해체 작업",
  },
  {
    content: "정격하중, 속도, 경고표시 등을 작업자가 보기 쉬운 곳에 부착한다.",
    isChecked: "",
    title: "양중 작업",
  },
  {
    content: "과부하장지장치, 권과방지장치, 비상정지장치 및 제동장치, 그 밖의 방호장치가 정상적으로 작동하는지 점검한다.",
    isChecked: "",
    title: "양중 작업",
  },
  {
    content: "적재하중을 초과하지 않도록 작업한다.",
    isChecked: "",
    title: "양중 작업",
  },
  {
    content: "훅 해지장치를 사용하여 인양물의 이탈을 방지한다.",
    isChecked: "",
    title: "양중 작업",
  },
  {
    content: "운전자는 운전위치를 이탈하지 않는다.",
    isChecked: "",
    title: "양중 작업",
  },
];
